import UserFormDTO from "@/models/form/UserFormDTO";
import TraderDTO from "@/models/TraderDTO";

export default interface TraderOperatorFormDTO extends UserFormDTO {
    trader: TraderDTO|null
}

export const defaultCreateForm = {
    id: null,
    name: null,
    email: null,
    password: '',
    isBlocked: false,
    createInvite: true,
    appId: null,
    trader: null
} as TraderOperatorFormDTO
